import { offlineDatabase } from '../database/offlineDatabase/offlineDatabase';
import { OfflineDatabaseKit } from '../database/offlineDatabase/types/offlineDatabaseKit.types';
import { createOfflineCommonRepository } from './common/createOfflineCommonRepository';

const commonRepository = createOfflineCommonRepository<OfflineDatabaseKit, 'id'>(
  () => offlineDatabase.kits,
);

export const offlineKitsRepository = {
  ...commonRepository,
  findByIds: (kitIds: string[]) => {
    if (!kitIds?.length) {
      return [];
    }

    const databaseTable = offlineDatabase.kits;
    return databaseTable.where('id').anyOf(kitIds).toArray();
  },
  findByExactCode: (code: string) => {
    const databaseTable = offlineDatabase.kits;
    return databaseTable.where('code').equalsIgnoreCase(code).first();
  },
};
